import { useEffect, useState } from "react";
import { findSigninAccount } from "../../helpers/hooks/useAccountFinder";
import { loginRequest, b2cPolicies, deployment } from "../../authConfig";
import { useMsal } from "@azure/msal-react";
import { EventType, InteractionType } from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";

export const InvitationLoggedIn = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id_token");
    const domain_hint = queryParams.get("domain_hint");
    const tenant = queryParams.get("tenant");
    const login_hint = queryParams.get("login_hint");
    console.log("id_token:" + id);

    const callbackId = instance.addEventCallback((event: any) => {
      console.log("event", event.eventType);
      if (event.eventType === EventType.LOGIN_FAILURE) {
        console.log("sign in failed:" + event.error.errorMessage);
        if (event.error && event.error.errorMessage.indexOf("AADB2C90118") > -1) {
          console.log("Forgot password");
        } else {
          console.log("login failed");
        }
      }

      if (event.eventType === EventType.LOGIN_SUCCESS) {
        if (event?.payload) {
          console.log("logged in....not redirecting to home page");
          sessionStorage.setItem("accessToken", event?.payload.accessToken);
          //window.top?.location.reload();
        }
      }
      if (event.eventType === EventType.HANDLE_REDIRECT_END) {
        //window.top?.location.assign("/Dashboard");
        //window.top?.location.assign("/");
        instance
          .loginRedirect({
            scopes: loginRequest.scopes,
            redirectUri: deployment.baseUrl + "/loggedin",
          })
          .then(() => {
            console.log("Redirected to login page");
          })
          .catch((err) => {
            console.log("Error in redirecting to login page", err);
            console.error(err);
          });
        //window.top?.location.reload();
      }

      if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
        if (event.interactionType === InteractionType.Redirect) {
          console.log("redirected");
        }
      }
    });
    if (domain_hint || login_hint || tenant) {
      instance.loginRedirect({
        scopes: loginRequest.scopes,
        loginHint: login_hint ?? "",
        extraQueryParameters: {
          domain_hint: domain_hint ?? "",
          tenant: tenant ?? "",
        },
      });
    }

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, []);

  return <div>{<p>Loading...</p>}</div>;
};
